var _defs, _rect, _g, _g2, _ellipse, _g3, _g4, _g5, _g6, _g7, _defs2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLudoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: "50%",
    cy: "40%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4C8DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#2E62E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1B3FA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dieFace",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#F2F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D8E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "red",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6B77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#FF4757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C21830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#FFC93C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EE8E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "green",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5CE68C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#2ED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#14913F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blue",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6FA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#3E8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1D5AD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#FFDD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFA400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crownGold",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEB70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5A100"
  })), /*#__PURE__*/React.createElement("path", {
    id: "pawn",
    d: "M -63,-196       A 64 64 0 1 1 63,-196       C 52,-152 32,-134 26,-120       C 62,-96 80,-58 88,-34       L 92,-26       A 92 26 0 0 1 -92,-26       L -88,-34       C -80,-58 -62,-96 -26,-120       C -32,-134 -52,-152 -63,-196 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "soft",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 14,
    stdDeviation: 16,
    floodColor: "#0B1E52",
    floodOpacity: 0.45
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(512,470)",
    opacity: 0.07,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rays"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-100,-820 L100,-820 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-100,-820 L100,-820 Z",
    transform: "rotate(30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-100,-820 L100,-820 Z",
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-100,-820 L100,-820 Z",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-100,-820 L100,-820 Z",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-100,-820 L100,-820 Z",
    transform: "rotate(150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-100,-820 L100,-820 Z",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-100,-820 L100,-820 Z",
    transform: "rotate(210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-100,-820 L100,-820 Z",
    transform: "rotate(240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-100,-820 L100,-820 Z",
    transform: "rotate(270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-100,-820 L100,-820 Z",
    transform: "rotate(300)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-100,-820 L100,-820 Z",
    transform: "rotate(330)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 200,
    r: 8,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 160,
    r: 6,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 420,
    r: 9,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 520,
    r: 6,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 640,
    r: 5,
    opacity: 0.4
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 512,
    cy: 756,
    rx: 340,
    ry: 48,
    fill: "#0B1E52",
    opacity: 0.35
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,636) scale(0.84)",
    filter: "url(#soft)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#pawn",
    fill: "url(#green)",
    stroke: "#123B22",
    strokeWidth: 12,
    paintOrder: "stroke"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -22,
    cy: -208,
    rx: 24,
    ry: 17,
    fill: "#FFFFFF",
    opacity: 0.75,
    transform: "rotate(-20 -22 -208)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(824,636) scale(0.84)",
    filter: "url(#soft)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#pawn",
    fill: "url(#blue)",
    stroke: "#0F2C66",
    strokeWidth: 12,
    paintOrder: "stroke"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -22,
    cy: -208,
    rx: 24,
    ry: 17,
    fill: "#FFFFFF",
    opacity: 0.75,
    transform: "rotate(-20 -22 -208)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(512,430) rotate(-8)",
    filter: "url(#soft)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -176,
    y: -172,
    width: 380,
    height: 380,
    rx: 88,
    fill: "#AEBBD2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -190,
    y: -190,
    width: 380,
    height: 380,
    rx: 88,
    fill: "url(#dieFace)",
    stroke: "#17224F",
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -150,-180 Q -20,-196 150,-160 Q 40,-120 -160,-90 Q -186,-140 -150,-180 Z",
    fill: "#FFFFFF",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: -95,
    cy: -95,
    r: 46,
    fill: "url(#red)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: -95,
    r: 46,
    fill: "url(#green)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -95,
    cy: 95,
    r: 46,
    fill: "url(#blue)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 95,
    r: 46,
    fill: "url(#yellow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 46,
    fill: "#17224F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -108,
    cy: -110,
    r: 13,
    fill: "#FFFFFF",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: -110,
    r: 13,
    fill: "#FFFFFF",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -108,
    cy: 80,
    r: 13,
    fill: "#FFFFFF",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 80,
    r: 13,
    fill: "#FFFFFF",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -13,
    cy: -15,
    r: 13,
    fill: "#FFFFFF",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-112,-176) rotate(-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -70,10 L -78,-60 L -34,-24 L 0,-78 L 34,-24 L 78,-60 L 70,10 Z",
    fill: "url(#crownGold)",
    stroke: "#8C4A00",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: 8,
    width: 140,
    height: 26,
    rx: 13,
    fill: "url(#crownGold)",
    stroke: "#8C4A00",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -78,
    cy: -66,
    r: 14,
    fill: "#FFE45C",
    stroke: "#8C4A00",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -84,
    r: 14,
    fill: "#FFE45C",
    stroke: "#8C4A00",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: -66,
    r: 14,
    fill: "#FFE45C",
    stroke: "#8C4A00",
    strokeWidth: 8
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(316,748) scale(1.12)",
    filter: "url(#soft)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#pawn",
    fill: "url(#red)",
    stroke: "#6E0E1C",
    strokeWidth: 12,
    paintOrder: "stroke"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -22,
    cy: -208,
    rx: 24,
    ry: 17,
    fill: "#FFFFFF",
    opacity: 0.8,
    transform: "rotate(-20 -22 -208)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -40,
    cy: -40,
    rx: 16,
    ry: 26,
    fill: "#FFFFFF",
    opacity: 0.3,
    transform: "rotate(14 -40 -40)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(708,748) scale(1.12)",
    filter: "url(#soft)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#pawn",
    fill: "url(#yellow)",
    stroke: "#8C4A00",
    strokeWidth: 12,
    paintOrder: "stroke"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -22,
    cy: -208,
    rx: 24,
    ry: 17,
    fill: "#FFFFFF",
    opacity: 0.8,
    transform: "rotate(-20 -22 -208)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -40,
    cy: -40,
    rx: 16,
    ry: 26,
    fill: "#FFFFFF",
    opacity: 0.3,
    transform: "rotate(14 -40 -40)"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "arc",
    d: "M 150,930 Q 512,830 874,930"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial Rounded MT Bold, Arial Black, sans-serif",
    fontSize: 200,
    fontWeight: 900,
    letterSpacing: 10,
    fill: "url(#gold)",
    stroke: "#7A2504",
    strokeWidth: 26,
    paintOrder: "stroke",
    strokeLinejoin: "round",
    filter: "url(#soft)"
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#arc",
    startOffset: "50%",
    textAnchor: "middle"
  }, "LUDO"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLudoIcon);
export default __webpack_public_path__ + "static/media/ludo-icon.64bed01bfb0eb2fea24c821f453f180a.svg";
export { ForwardRef as ReactComponent };